/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react-hooks/rules-of-hooks */
import { ReactHTML, ReactNode, useState } from 'react'

import classNames from 'classnames'
import { useEffectOnce } from 'react-use'

import ErrorBoundary from '../ErrorBoundary'
import styles from './Advertisement.module.scss'
import { AdInitProps, useAdvertisement } from './useAdvertisement'
import { cleanUpAd, getAdHeightByType, useAdEvent } from './utils'
import PlaceSection from '../PlaceSection/PlaceSection'

// TODO: 광고 컴포넌트도 UI 컴포넌트로 분리
export enum AdType {
  SMART_CHANNEL = 'm_myplace_top', // 스마트 채널
  M_SUB = 'm_myplace_msub', // M서브
  FEED = 'm_myplace_feed', // 추천구독형 피드 (비율 혼용, 리뷰피드 & 피드탭)
  FEED_REVIEW_TAB = 'm_myplace_feed_reviewtab', // 추천구독형 (16:9, 리뷰탭 only)
  FEED_REVIEW_END = 'm_myplace_feed_reviewend', // 홈피드형 (리뷰엔드 only)
}

export enum AdPage {
  HOME_TAB = 'myhome', // 홈탭 (MY통합 신규) - TODO: AdPage 홈페이지 신규 페이지 주소 필요한지 확인
  TIMELINE_TAB = 'timeline', // 타임라인탭 (MY통합 신규) - TODO: AdPage 타임라인페이지 신규 페이지 주소 필요한지 확인
  TIMELINE_END = 'timelineend', // 타임라인_엔드
  REVIEW_TAB_MINE = 'review1', // 리뷰탭_본인
  REVIEW_TAB_OTHERS = 'review2', // 리뷰탭_타인
  REVIEW_FEED_MINE = 'reviewfeed1', // 리뷰피드_본인
  REVIEW_FEED_OTHERS = 'reviewfeed2', // 리뷰피드_타인
  REVIEW_END_MINE = 'reviewend1', // 리뷰엔드_본인
  REVIEW_END_OTHERS = 'reviewend2', // 리뷰엔드_타인
  FEED_TAB = 'feed', // 피드탭 (MY통합 fade-out)
  PLACE_TAB = 'place', // 저장탭 (MY통합 fade-out)
}

interface ADProps extends Omit<AdInitProps, 'adSlotElementIds'> {
  adSlotElementId: string

  /**
   * 광고 노출위치 목록 (컨텐츠 사이에 중간광고 노출될때 중복제거돼야하는 경우 추가)
   * @link https://oss.navercorp.com/place/local/issues/16069
   */
  adSlotElementIds?: string[]

  /**
   * 광고가 붙여질 엘리먼트의 tag 종류
   * 기본값: div
   */
  tag?: keyof ReactHTML
  className?: string
  defaultHeight?: number
  marginTop?: number
}

/**
 * GLAD SDK 광고 모듈 활용
 * [SDK GUIDE](https://naver.github.io/nam-sdk-guide/web)
 */
const _Advertisement = ({
  type,
  page,
  userIdno: userIdno,
  adSlotElementId,
  adSlotElementIds,
  marginTop,
  tag: TagName = 'div',
  className,
}: ADProps) => {
  const [hide, setHide] = useState(false)

  const { skipAd } = useAdvertisement({
    adSlotElementIds: adSlotElementIds ?? [adSlotElementId],
    type,
    page,
    userIdno,
  })

  useAdEvent('AD_MUTE_COMPLETED', ad => {
    const target = ad.slot.getAdSlotElementId()
    if (target === adSlotElementId) setHide(true)
  })

  useAdEvent('ERROR', ad => {
    const target = ad.slot.getAdSlotElementId()
    if (target === adSlotElementId) setHide(true)
  })

  useEffectOnce(() => {
    return () => cleanUpAd(adSlotElementId)
  })

  if (hide || skipAd) return null

  const { minHeight } = getAdHeightByType(type)

  return (
    <TagName
      id={adSlotElementId}
      className={classNames(className, styles.ad_area, {
        [styles.type_feed]: [AdType.FEED, AdType.FEED_REVIEW_END, AdType.FEED_REVIEW_TAB].includes(type),
      })}
      style={{ minHeight, marginTop }}
    />
  )
}

const Advertisement = (props: ADProps) => {
  return (
    <ErrorBoundary fallback={null}>
      <_Advertisement {...props} />
    </ErrorBoundary>
  )
}
export default Advertisement

interface PlaceSectionForAdProps {
  children?: ReactNode
  isSmartChannel?: boolean
  className?: string
  isTransparentBg?: boolean
}

export const PlaceSectionForAd = ({ children, className, isSmartChannel, isTransparentBg }: PlaceSectionForAdProps) => {
  return (
    <PlaceSection
      className={classNames(styles.ad_section, className, { [styles.type_smart_channel]: isSmartChannel })}
      isNoPaddingHorizontal
      isTransparentBg={isTransparentBg}
    >
      {children}
    </PlaceSection>
  )
}
